// extracted by mini-css-extract-plugin
module.exports = {"container":"News_container__20aFZ","newscontainer":"News_newscontainer__1Zsjr"};